module.exports = __webpack_public_path__ + "static/media/Orcamentos2.24702100.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos2.png
// module id = 2098
// module chunks = 0